$(document).ready(function() {

  $(document).on("change", ".upload_image", function(){
    var user_id = $("#user_id").val();
    var form = $(this).closest('#main-user-form');
    var authenticity_token = $(form).find('#authenticity_token').val();

    var images = $(form).find('.upload_image')[0].files
    var formData = new FormData();

    var obj = {};
    obj["id"] = user_id;
    obj = JSON.stringify(obj);
    formData.append('profile_photo',images[0]);
    formData.append('authenticity_token',authenticity_token);
    formData.append('user',obj);

    $.ajax({
      type:'PUT',
      url:'/admin/users/' + user_id + '/upload_image',
      processData: false,
      contentType: false,
      data: formData
    });
  });

  $(document).on("change", ".upload_office_logo", function(){
    var office_id = $("#office_id").val();
    var form = $(this).closest('#office-payment-form');
    var authenticity_token = $(form).find('#authenticity_token').val();

    var images = $(form).find('.upload_office_logo')[0].files
    var formData = new FormData();

    var obj = {};
    obj["id"] = office_id;
    obj = JSON.stringify(obj);
    formData.append('office_logo',images[0]);
    formData.append('authenticity_token',authenticity_token);
    formData.append('office',obj);

    $.ajax({
      type:'PUT',
      url:'/admin/offices/' + office_id + '/upload_office_logo',
      processData: false,
      contentType: false,
      data: formData
    });
  });

  $(document).on("click", ".contract_group_save", function(){
    var form = $(this).closest('.contract_group_form');
    var authenticity_token = $(form).find('#authenticity_token').val();
    var name = $(form).find('#contract_group_name').val();
    var contract_group_id = $(form).find('#contract_group_id').val();
    var office_id = $(form).find('#id').val();
    var obj = {};
    obj["name"] = name;

    $.ajax({
      type:'PUT',
      url:'/admin/offices/' + office_id + '/update_contract_group/' + contract_group_id,
      data: { authenticity_token : authenticity_token, id : office_id, contract_group_id : contract_group_id, contract_group : obj },
      success:function(){
      }
    });
  });

  $(document).on("click", ".contract_save", function(){
    var id = getId(this.id);
    var form = $(this).closest('.contract_form');
    var authenticity_token = $(form).find('#authenticity_token').val();
    var contract_group_id = $(form).find('#contract_group_id').val();
    var name = $(form).find('.contract_name').val();
    var alarm_date = $(form).find('.alarm_date').val();
    var office_id = $(form).find('#id').val();
    var contract_id = $(form).find('#contract_id').val();
    var creator_id = $(form).find('#creator_id').val();
    var updater_id = $(form).find('#updater_id').val();
    var formData = new FormData();
    var images = $(form).find('.groupContractMedia')[0].files

    remove_validation_text($(".contract_form"));
    var obj = {};
    obj["name"] = name;
    obj["alarm_date"] = alarm_date;
    obj["creator_id"] = creator_id;
    obj["updater_id"] = updater_id;
    obj = JSON.stringify(obj);
    formData.append('attachment',images[0]);
    formData.append('authenticity_token',authenticity_token);
    formData.append('id',office_id);
    formData.append('contract_group_id',contract_group_id);
    formData.append('contract',obj);
    formData.append('contract_id',contract_id);

    $.ajax({
      type:'PUT',
      url:'/admin/offices/' + office_id + '/update_contract/' + contract_id,
      processData: false,
      contentType: false,
      data: formData,
      success:function(){
      }
    });
  });

  $(document).on("click", ".contract_group_create", function(){
    var form = $(this).closest('.contract_group_form');
    var authenticity_token = $(form).find('#authenticity_token').val();
    var element_id = $(form).find('#element_id').val();
    var name = $(form).find('#contract_group_name').val();
    var document_type = $(form).find('#document_type').val();
    var office_id = $(form).find('#id').val();
    var obj = {};
    obj["name"] = name;
    obj["document_type"] = document_type;

    $.ajax({
      type:'POST',
      url:'/admin/offices/' + office_id + '/create_contract_group',
      data: { authenticity_token : authenticity_token, element_id : element_id, id : office_id, contract_group : obj },
      success:function(){
      }
    });
  });

  $(document).on("click", ".contract_create", function(e){
    var form = $(this).closest('.contract_parent');
    var authenticity_token = $(form).find('#authenticity_token').val();
    var element_id = $(form).find('#element_id').val();
    var contract_group_id = $(form).find('#contract_group_id').val();
    var name = $(form).find('.contract_name').val();
    var alarm_date = $(form).find('.alarm_date').val();
    var office_id = $(form).find('#id').val();
    var creator_id = $(form).find('#creator_id').val();
    var updater_id = $(form).find('#updater_id').val();
    var formData = new FormData();
    var images = $(form).find('.groupContractMedia')[0].files

    remove_validation_text($(".contract_parent"));
    var obj = {};
    obj["name"] = name;
    obj["alarm_date"] = alarm_date;
    obj["creator_id"] = creator_id;
    obj["updater_id"] = updater_id;
    obj = JSON.stringify(obj);
    formData.append('attachment',images[0]);
    formData.append('authenticity_token',authenticity_token);
    formData.append('element_id',element_id);
    formData.append('id',office_id);
    formData.append('contract_group_id',contract_group_id);
    formData.append('contract',obj);

    $.ajax({
      type:'POST',
      url:'/admin/offices/'+ office_id + '/create_contract',
      processData: false,
      contentType: false,
      data: formData,
      success:function(){
      }
    });
  });

  //show contract group form on clicking edit group btn
  $(document).on("click", ".contract_group_edit", function(){
    var id = getId(this.id);
    $("#contract_group_form_" + id).removeClass('hide');
  });

  //hide contract group form on clicking cancel btn
  $(document).on("click", ".contract_group_cancel", function(){
    var id = getId(this.id);
    $("#contract_group_lbl_" + id).removeClass('hide');
    $("#contract_group_form_" + id).addClass('hide');
  });

  //remove the create contract_group/contract form when clicked on remove btn
  $(document).on("click", ".contract_group_remove", function(){
    $("#" + getId(this.id)).remove();
  });

  $(document).on('click', '.contract_remove', function(){
    var id = getId(this.id);
    $("#" + id).remove();
  });

  //enable filename box and show save,cancel and remove btns contract on clicking edit contract btn
  $(document).on("click", ".contract_edit", function(){
    var id = getId(this.id);
    $(this).addClass('hide');
    $("#contract_detail_" + id).removeClass("hide");
    $("#contract_file_" + id).addClass("hide");
    $("#contract_form_" + id).removeClass("hide");
    $("#contract_remove_" + id).removeClass("hide");
    $("#contract_cancel_" + id).removeClass("hide");
  });

  $(".separate_visiting_address").on("click",function(){
    var address = $(this).val();
    if(address == "true") {
      $(".visiting_address_info").removeClass("hide");
    }else{
      $(".visiting_address_info").addClass("hide");
    }
  });

  $(".email_invoice_address").on("click",function(){
    var address = $(this).val();
    if(address == "true") {
      $(".invoice_address_info").removeClass("hide");
    }else{
      $(".invoice_address_info").addClass("hide");
    }
  });

  $(".electronic_billing_address").on("click",function(){
    var address = $(this).val();
    if(address == "true") {
      $(".billing_address_info").removeClass("hide");
    }else{
      $(".billing_address_info").addClass("hide");
    }
  });

  $("#moreOptionsBtn").click(function(){
    $("#opening-hours-loader").show();
  });
});

function getId(id){
  var idArr = id.split("_");
  return idArr[idArr.length - 1];
}

function display_validation_text(element,msg){
  $(element).parent().closest('div').addClass('has-error');
  $(element).parent().closest('div').find('small:eq(0)').remove();
  $(element).parent().closest('div').find('i:eq(0)').remove();
  $(element).parent().closest('div').append('<i class="form-control-feedback fa fa-remove" style="top: 0px;"></i>'); 
  $(element).parent().closest('div').append('<small class="help-block">'+msg+'</small>');
}

function remove_validation_text(element){
  $(element).parent().closest('div').removeClass('has-error');
  $(element).parent().closest('div').find('small:eq(0)').remove();
  $(element).parent().closest('div').find('i:eq(0)').remove();
}